import { TableContainer as TableContainerMui } from '@mui/material';

export default TableContainerMui;
